var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSchoolBuilding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_125130",
    "data-name": "Path 125130",
    d: "M14.375-3.75h-3.75A.625.625,0,0,0,10-3.125v5a.625.625,0,0,0,.625.625h3.75A.625.625,0,0,0,15,1.875v-5A.625.625,0,0,0,14.375-3.75ZM12.5-12.812A3.438,3.438,0,0,0,9.062-9.375,3.438,3.438,0,0,0,12.5-5.937a3.438,3.438,0,0,0,3.437-3.437A3.438,3.438,0,0,0,12.5-12.812Zm1.875,4.375a.312.312,0,0,1-.312.312H12.187a.312.312,0,0,1-.312-.312v-2.5a.312.312,0,0,1,.313-.312h.625a.312.312,0,0,1,.313.313v1.562h.937a.312.312,0,0,1,.312.312ZM23.75-10H20v-2.083a1.25,1.25,0,0,0-.557-1.04l-6.25-4.167A1.24,1.24,0,0,0,12.5-17.5h0a1.247,1.247,0,0,0-.693.21l-6.25,4.167A1.247,1.247,0,0,0,5-12.084V-10H1.25A1.25,1.25,0,0,0,0-8.75V1.875A.625.625,0,0,0,.625,2.5H1.25a.625.625,0,0,0,.625-.625v-10H5V2.5H6.875V-11.749L12.5-15.5l5.625,3.75V2.5H20V-8.125h3.125v10a.625.625,0,0,0,.625.625h.625A.625.625,0,0,0,25,1.875V-8.75A1.25,1.25,0,0,0,23.75-10Z",
    transform: "translate(0 17.5)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSchoolBuilding);
export default __webpack_public_path__ + "static/media/Icon-SchoolBuilding.a12482dc56bb818c829b7931443b4a00.svg";
export { ForwardRef as ReactComponent };